// extracted by mini-css-extract-plugin
module.exports = {"detail":"BuyLoadProductConfirm_detail__2u3m5"};